import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { ReactComponent as DuplicateSVG } from '../../../../../../assets/svg/invoices-icons/icon-duplicate-action.svg';

export const ShareLinkAction = ({ linkToShare, onClose }: { linkToShare: string; onClose: () => void }) => {
  const [isCopyActive, setIsCopyActive] = useState(false);
  const { t } = useTranslation();
  const handleOnDoneClick = () => {
    if (onClose) onClose();
  };
  useEffect(() => {
    if (isCopyActive) {
      window.navigator.clipboard.writeText(linkToShare || '');
      setTimeout(() => {
        setIsCopyActive(false);
      }, 1500);
    }
  }, [isCopyActive]);
  return (
    <div className='flex flex-wrap h-[186px] w-[568px] bg-bw01 rounded-lg border-[1px] border-bw03 pt-[20px] pb-[24px] px-[24px] box-border'>
      <div className='font-metricMedium text-bw08 text-lg leading-[1.625rem]'>
        {t('INVOICE_HUB_MODALS.SHARE_LINK.TITLE')}
      </div>
      <div className='h-[44px] w-[520px] rounded-lg border-[1px] border-bw04 bg-bw02 mt-[12px] flex items-center pl-[16px] justify-between box-border'>
        <div
          className='w-[435px] font-metricR text-md text-bw07 leading-6 overflow-hidden whitespace-nowrap text-ellipsis'
          id='invoice-share-link'
        >
          {linkToShare}
        </div>
        <div className='flex w-[128px] h-full justify-end cursor-pointer'>
          <LiliButton
            id='elBtnShareUrl'
            type={LiliButtonType.TERTIARY}
            icon={<DuplicateSVG className='stroke-action03 inline-block' />}
            title={isCopyActive ? t('INVOICE_HUB_MODALS.SHARE_LINK.COPIED') : t('INVOICE_HUB_MODALS.SHARE_LINK.COPY')}
            onClick={() => setIsCopyActive(true)}
            className='w-[128px] h-full rounded-r-lg !rounded-l-none'
          />
        </div>
      </div>
      <div className='flex w-full justify-end'>
        <LiliButton
          id='invoice-share-link-cta'
          title={t('INVOICE_HUB_MODALS.SHARE_LINK.CTA')}
          className='w-[114px] h-[40px] mt-[20px]'
          onClick={handleOnDoneClick}
        />
      </div>
    </div>
  );
};
